<template>
	<div>
		<DetailTitle title="조회 기간"></DetailTitle>

		<SearchDateRange
			:start-date="searchStartDate"
			:end-date="searchEndDate"
			@search="search"
		/>

		<div class="coupon-container u-container">
			<ul class="user-coupon-list">
				<li
					v-for="item in userCouponList"
					:key="item.couponNo"
					class="user-coupon-list__item"
				>
					<CouponItem :item="item"></CouponItem>
				</li>
			</ul>

			<InfiniteLoading
				v-if="isInfiniteLoading"
				ref="infiniteLoading"
				@infinite="infinite"
			></InfiniteLoading>
		</div>
	</div>
</template>

<script>
import DetailTitle from '@/components/common/DetailTitle';
import SearchDateRange from '@/components/common/SearchDateRange';
import InfiniteLoading from '@/components/common/InfiniteLoading';
import CouponItem from './CouponItem';

import { formatDate } from '@/utils/util';

export default {
	components: {
		DetailTitle,
		SearchDateRange,
		InfiniteLoading,
		CouponItem,
	},
	data() {
		return {
			page: 1,
			startDate: '',
			endDate: '',
			isInfiniteLoading: false,
		};
	},
	computed: {
		limitStartDate() {
			return new Date('2022-01-1');
		},
		searchStartDate() {
			const date = new Date();
			date.setMonth(date.getMonth() - 3);
			return this.limitStartDate.getTime() > date.getTime()
				? this.limitStartDate
				: date;
		},
		searchEndDate() {
			return new Date();
		},
		userId() {
			return this.$store.getters['userStore/userId'];
		},
		userCouponList() {
			return this.$store.getters['couponStore/userCouponList'];
		},
	},
	created() {
		this.initUserCouponList();
	},
	methods: {
		async fetchUserCouponList() {
			const payload = {
				userId: this.userId,
				page: this.page,
				startDate: this.startDate,
				endDate: this.endDate,
			};
			return await this.$store.dispatch(
				'couponStore/getUserCouponList',
				payload,
			);
		},
		initUserCouponList() {
			this.$store.dispatch('couponStore/initUserCouponList');
		},
		infinite(state) {
			this.fetchUserCouponList().then(({ data }) => {
				if (data.code !== '00000' || data.page > data.totalPage) {
					this.page--;
					state.complete();
				}
				if (data.page <= data.totalPage) {
					this.page++;

					/**
					 * 데이터 가져오는 속도가 빨라서
					 * 스크롤시 무한 스크롤링 로딩 아이콘 노출 시간이 짧아서 보이지 않음.
					 * 임의로 가져오는 속도 늦춤.
					 */
					setTimeout(() => state.loaded(), 400);
				}
			});
		},
		setDateRange(date) {
			this.startDate = formatDate(date.start, '');
			this.endDate = formatDate(date.end, '');
		},
		search(date) {
			this.setDateRange(date);

			this.isInfiniteLoading === false
				? (this.isInfiniteLoading = true)
				: this.initRender();
		},
		initRender() {
			this.page = 1;
			this.initUserCouponList();
			this.$refs.infiniteLoading.resetInfiniteLoading();
		},
	},
};
</script>

<style scoped>
.coupon-container {
	padding: 1.875rem 0;
}

.user-coupon-list__item {
	margin: 1.125rem 0 0;
}

.user-coupon-list__item:first-child {
	margin-top: 0;
}
</style>
